import GoogleMap from 'components/GoogleMap'

export default function () {
  const mapEl = document.getElementById('cruise-ship-map')
  if (!mapEl) return
  new GoogleMap(mapEl)
}
